// Единый источник правды для порогов калибрации (план/факт по минутам).
//
// Зоны строятся по ratio (= факт / план × 100):
//   < 80%   — cool (переоценили — можно поджимать)
//   80-120% — good (попали в план)
//   120-200% — warn (умеренный перерасход)
//   > 200%  — bad (крупная недооценка — нужна калибровка)
//
// Используется:
//   - components/task-inspector.js — per-task бейдж
//   - views/calibration.js — таблица и распределение
//   - views/dashboard.js — виджет «Точность оценок»
//   - views/gantt.js — окраска baseline-полоски (ahead / late)
//
// Менять пороги — здесь, в одном месте. SQL-VIEW в миграции 026 намеренно
// НЕ содержит поле `zone` — числа отдаёт backend, цвета считает фронт.

export const ZONE_THRESHOLDS = Object.freeze({
  // Верхняя граница для каждой зоны (инклюзивно).
  cool: 80,    // < 80
  good: 120,   // 80..120
  warn: 200,   // 120..200
  // bad: всё что > 200
});

export const ZONE_LABELS = Object.freeze({
  cool: 'Переоценили — можно поджимать',
  good: 'Попали в план',
  warn: 'Умеренный перерасход',
  bad:  'Крупная недооценка — нужна калибровка',
});

export const ZONE_ORDER = Object.freeze(['cool', 'good', 'warn', 'bad']);

/**
 * Вернуть зону по ratio_pct (= актуал / план × 100).
 * Возвращает null если ratio невалиден.
 */
export function getZone(ratioPct) {
  const r = Number(ratioPct);
  if (!Number.isFinite(r) || r <= 0) return null;
  if (r < ZONE_THRESHOLDS.cool) return 'cool';
  if (r <= ZONE_THRESHOLDS.good) return 'good';
  if (r <= ZONE_THRESHOLDS.warn) return 'warn';
  return 'bad';
}

/**
 * Вернуть ratio_pct по плану и факту в минутах. null если расчёт невозможен.
 */
export function calcRatio(planMin, factMin) {
  const p = Number(planMin);
  const f = Number(factMin);
  if (!Number.isFinite(p) || !Number.isFinite(f) || p <= 0 || f <= 0) return null;
  return (f / p) * 100;
}
